import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Link, useOutletContext } from 'react-router-dom';
import { Hero } from '../../components/home/Hero';
import type { HeroTreatment } from '../../components/home/Hero';
import { CuisineMarquee } from '../../components/home/CuisineMarquee';
import { ProofStrip } from '../../components/home/ProofStrip';
import { SignatureShowcase } from '../../components/home/SignatureShowcase';
import { ServiceAreaVector } from '../../components/home/ServiceAreaVector';
import { HowItWorks } from '../../components/home/HowItWorks';
import { Voices } from '../../components/home/Voices';
import { ChefRecruit } from '../../components/home/ChefRecruit';
import { FeaturedChefCard } from '../../components/chefs/FeaturedChefCard';
import { ChefCard } from '../../components/chefs/ChefCard';
import { SectionHeading } from '../../components/ui/Panels';
import { chefs } from '../../data/chefs';
import { popItem, staggerContainer, viewportOnce } from '../../utils/motion';
interface HomeOutletContext {
  heroTreatment?: HeroTreatment;
}
export function Home() {
  const reduce = useReducedMotion();
  const context = useOutletContext<HomeOutletContext | null>();
  const heroTreatment = context?.heroTreatment ?? 'editorial';
  const [featured, ...rest] = chefs;
  return <>
      <Hero treatment={heroTreatment} data-id="element-2246" data-mp="jxw63u4qhjnf" />
      <CuisineMarquee data-id="element-2247" data-mp="jwut3k45qn32" />
      <ProofStrip data-id="element-2248" data-mp="jwb8twr1bmlv" />

      <section aria-labelledby="featured-heading" className="mx-auto max-w-shell px-5 py-20 lg:px-8 lg:py-24" data-id="element-2249" data-mp="ez2rtzhmhom7">
        <SectionHeading level={2} title="Chefs cooking near Carroll Gardens" hint="Ranked by how well they fit a six-person dinner on a Saturday." action={<Link to="/discover" className="inline-flex items-center gap-1.5 text-sm font-medium text-primary underline decoration-primary/30 underline-offset-4 hover:decoration-primary" data-id="element-2251" data-mp="12oduxnmg3v3i">
              See all chefs
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2252" data-mp="3rjdetw3ffaui" />
            </Link>} data-id="element-2250" data-mp="tnpg4qp89qpk" />

        <div className="mt-9" data-id="element-2253" data-mp="94xrn74xyni">
          <FeaturedChefCard chef={featured} reason="Fastest to quote in your area" data-id="element-2254" data-mp="4d2whwsjt7g1" />
        </div>

        <motion.ul variants={staggerContainer(0.05)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2255" data-mp="93ayzujt3xtu">
          {rest.slice(0, 3).map(chef => <motion.li key={chef.id} variants={popItem(reduce)} data-id="element-2256" data-mp="j3jzhkku05f1">
              <ChefCard chef={chef} data-id="element-2257" data-mp="o1bp27y07fg2" />
            </motion.li>)}
        </motion.ul>
      </section>

      <ServiceAreaVector data-id="element-2258" data-mp="s1m5yfnc3q9p" />
      <SignatureShowcase data-id="element-2259" data-mp="s02lsdyk4v2n" />
      <HowItWorks data-id="element-2260" data-mp="2psopoksxv16b" />
      <Voices data-id="element-2261" data-mp="2pt87m1il9pkc" />
      <ChefRecruit data-id="element-2262" data-mp="2ptrjb0hnbhpx" />
    </>;
}